import { render, staticRenderFns } from "./SystemInit.vue?vue&type=template&id=5b8841e9&scoped=true"
import script from "./SystemInit.vue?vue&type=script&lang=js"
export * from "./SystemInit.vue?vue&type=script&lang=js"
import style0 from "./SystemInit.vue?vue&type=style&index=0&id=5b8841e9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8841e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b8841e9')) {
      api.createRecord('5b8841e9', component.options)
    } else {
      api.reload('5b8841e9', component.options)
    }
    module.hot.accept("./SystemInit.vue?vue&type=template&id=5b8841e9&scoped=true", function () {
      api.rerender('5b8841e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/SystemInit/SystemInit.vue"
export default component.exports